export default "__VITE_ASSET__MoP3E7nf__"